import { initialBpState } from './state'

export const selectWikiByBp = (state, bpId) =>
  state.buildingWiki?.byBpId?.[bpId] || initialBpState

export const selectWikiArticle = (state, bpId) =>
  selectWikiByBp(state, bpId).article

export const selectWikiStatus = (state, bpId) =>
  selectWikiByBp(state, bpId).status

export const selectWikiRefreshInFlight = (state, bpId) =>
  selectWikiByBp(state, bpId).refreshInFlight
